<div class="row m-0">
    <div class="col-12 col-lg-7 p-0 position-relative">
        <img src="./assets/images/Background.png" class="w-100" alt="Background Image">
        <div class="row m-0 white-box-container position-absolute w-100">
            <div
                class="offset-1 col-10 offset-md-2 col-md-8 offset-xl-3 col-xl-6 px-5 pt-5 pb-4 position-relative bg-white-90">
                <img src="./assets/images/dewalt-100-years-logo-1.svg" class="ms-5 start-0 w-auto position-absolute"
                    alt="Logo">
                <h1 class="ff-bold">
                    BUILT FOR HEAVY LIFTING
                </h1>
                <p class="ff-light text-dark mt-3">
                    Meet the DEWALT® TOUGHSERIES™ Construction Jack. With up to 340 lbs. of lifting capacity*, there’s
                    so much on the jobsite it can lift. Including your confidence working solo.
                </p>
            </div>
        </div>
    </div>
    <div class="col-12 col-lg-5 px-0 pb-0 mt-5 pt-5 mt-lg-0 pt-lg-0 ">
        <div class="row m-0 h-100">
            <div
                class="offset-1 col-10 offset-md-2 col-md-8 offset-lg-2 col-lg-8 offset-xl-3 col-xl-6 p-0 align-content-center">
                <img class="w-100" src="./assets/images/Logo.png" alt="Main Logo">
                <h1 class="ff-bold mt-4">
                    Bienvenido!
                </h1>
                <h5 class="ff-bold">
                    Anexo 24 Rubro C de la Empresa
                </h5>
                <!-- <p class="text-gray">
                    DEWALT: Puebla
                </p> -->

                <form [formGroup]="loginForm" class="row m-0 mt-4" (ngSubmit)="login()">
                    <div class="form-group position-relative px-0 pb-4">
                        <label class="form-label">
                            Usuario
                        </label>
                        <input class="form-control" formControlName="email" type="email">
                        <div *ngIf="email?.invalid && email?.errors && (email?.touched||email?.dirty)"
                            class="text-danger position-absolute bottom-0 start-0">
                            <p *ngIf="email?.errors?.['required']" class="mb-0">
                                Usuario Requerida.
                            </p>
                            <p *ngIf="email?.errors?.['pattern']" class="mb-0">
                                inválida Usuario.
                            </p>
                        </div>
                    </div>
                    <div class="form-group position-relative px-0 pb-4">
                        <label class="form-label">
                            Contrasenia
                        </label>
                        <div class="position-relative password-field">
                            <input class="form-control pe-5" formControlName="password" type="{{inputType}}">
                            <img *ngIf="inputType=='password'"
                                class="position-absolute top-50 end-0 translate-middle-y pe-3 pointer"
                                src="./assets/images/pwd-show.png" alt="Show Password"
                                (click)="inputType='text'">
                            <img *ngIf="inputType=='text'"
                                class="position-absolute top-50 end-0 translate-middle-y pe-3 pointer"
                                src="./assets/images/pwd-hide.png" alt="Hide Password"
                                (click)="inputType='password'">
                        </div>
                        <div *ngIf="password?.invalid && password?.errors && (password?.touched||password?.dirty)"
                            class="text-danger position-absolute bottom-0 start-0">
                            <p *ngIf="password?.errors?.['required']" class="mb-0">
                                Contrasenia Requerida.
                            </p>
                            <p *ngIf="password?.errors?.['pattern']" class="mb-0">
                                inválida Contrasenia.
                            </p>
                            
                        </div>
                    </div>
                    <!-- <div class="form-group px-0 pb-4">
                        <input type="checkbox" name="" id="remember">
                        <label for="remember" class="form-label ms-3 pointer">
                            Remember Me
                        </label>
                    </div> -->
                    <div *ngIf="errorDisplay" class="text-danger bottom-0 start-0">
                        <p class="mb-0">
                            Nombre de usuario o contraseña no válidos.
                        </p>
                    </div>
                    <div class="form-group px-0 mt-4">
                        <button class="form-control btn btn-dark" type="submit" [disabled]="loginForm.invalid">
                            Accesar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>